import { motion } from "framer-motion";

const ButtonCard = ({
  buttons = [],
  rightElement = null,
  heading = "Offer Actions",
  subHeading = "",
}) => {
  if (!buttons.length && !rightElement) return null;

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.35, ease: "easeOut" }}
      whileHover={{ y: -2 }}
      className="w-full rounded-xl border border-transparent backdrop-blur-md shadow-lg p-3"
      style={{
        background:
          "linear-gradient(160deg, #ffffff 0%, #f5faff 100%) padding-box, linear-gradient(125deg, rgba(130, 168, 216, 0.45) 0%, rgba(122, 163, 214, 0.45) 50%, rgba(140, 180, 226, 0.45) 100%) border-box",
        boxShadow: "0 12px 24px rgba(23, 61, 111, 0.12)",
      }}
    >
      <div className="flex w-full flex-col gap-2">
        <div className="min-w-0">
          {subHeading && (
            <p className="m-0 mt-1 text-[13px] text-slate-600">
              {subHeading}
            </p>
          )}
        </div>

        <div className="flex w-full flex-wrap items-center justify-between gap-2">
          <div className="flex flex-wrap items-center gap-2">
            {buttons.map((btn, index) => (
              <motion.button
                key={index}
                type="button"
                onClick={btn.onClick}
                whileHover={{ y: -2, scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                className="flex items-center gap-2 rounded-lg px-3 py-1.5 text-white text-sm font-semibold shadow-md transition hover:opacity-90 ring-1 ring-white/20"
                style={{
                  backgroundImage:
                    "linear-gradient(120deg, #6366f1 0%, #2563eb 100%)",
                }}
              >
                {btn.icon && <span className="text-base">{btn.icon}</span>}
                <span>{btn.label}</span>
              </motion.button>
            ))}
          </div>

          {rightElement && <div className="shrink-0">{rightElement}</div>}
        </div>
      </div>
    </motion.div>
  );
};

export default ButtonCard;
